import { gray70 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var MuiTooltip = {
    styleOverrides: {
        arrow: {
            color: gray70,
        },
        tooltip: {
            boxShadow: "0 ".concat(rem(1), " ").concat(rem(2), " #0000004D"),
            backgroundColor: gray70,
        },
    },
};
